import { useTranslations } from "next-intl";
import { useUserBillingAddress, useDeliveryPickupCarriersFor } from "@hooks/use-addresses";
import { Input, Button } from "@components/core";
import deliveryModes from "@utils/constants/deliveryModes";

const DeliveryModeChoice = ({
  onChange,
  currentMode,
  currentAddress,
  onChangeAddress,
  hideChangeAddress,
  onChangeRelayPoint,
  hideChangeRelayPoint,
}) => {
  const t = useTranslations("addresses");

  const userBillingAddress = useUserBillingAddress();
  const pickupCarriers = useDeliveryPickupCarriersFor(userBillingAddress?.country);

  return (
    <div className="mt-4 d-flex flex-column">
      <h6>{t("shipping_form.select_delivery_mode")}</h6>

      <div className="mt-3 p-3 w-100 bg-white rounded-lg">
        <Input
          type="radio"
          label={t("shipping_form.home")}
          className="font-size-sm m-0"
          checked={currentMode === deliveryModes.home}
          value={deliveryModes.home}
          onChange={onChange}
        />

        {currentMode === deliveryModes.home &&
          currentAddress?.delivery_mode === deliveryModes.home && (
            <>
              <div className="mt-3 font-weight-bold">
                {currentAddress?.first_name} {currentAddress?.last_name}
                <br />
                {currentAddress?.line1} {currentAddress?.line2 && <br />}
                {currentAddress?.line2}
                <br />
                {currentAddress?.zip} {currentAddress?.city}, {currentAddress?.country}
              </div>
              <Button
                variant="link-primary no-underline mt-3"
                onClick={onChangeAddress}
                hidden={hideChangeAddress}
              >
                {t("shipping_form.change_address")}
              </Button>
            </>
          )}
      </div>

      {pickupCarriers?.length > 0 && (
        <div className="mt-3 p-3 w-100 bg-white rounded-lg">
          <Input
            type="radio"
            label={t("shipping_form.relay_point")}
            className="font-size-sm m-0"
            checked={currentMode === deliveryModes.pickup}
            value={deliveryModes.pickup}
            onChange={onChange}
          />

          {currentMode === deliveryModes.pickup &&
            currentAddress?.delivery_mode === deliveryModes.pickup && (
              <>
                <div className="mt-3 font-weight-bold">
                  {currentAddress?.info}
                  <br />
                  {currentAddress?.line1} {currentAddress?.line2 && <br />}
                  {currentAddress?.line2}
                  <br />
                  {currentAddress?.zip} {currentAddress?.city}, {currentAddress?.country}
                </div>
                <Button
                  variant="link-primary no-underline mt-3"
                  onClick={onChangeRelayPoint}
                  hidden={hideChangeRelayPoint}
                >
                  {t("shipping_form.change_pickup")}
                </Button>
              </>
            )}
        </div>
      )}
    </div>
  );
};

export default DeliveryModeChoice;
